import { render } from "./DrivingClinic.vue?vue&type=template&id=1d107aa0&scoped=true&ts=true"
import script from "./DrivingClinic.vue?vue&type=script&lang=ts"
export * from "./DrivingClinic.vue?vue&type=script&lang=ts"

import "./DrivingClinic.vue?vue&type=style&index=0&id=1d107aa0&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d107aa0"]])

export default __exports__